//

var rn = {

    defaults: {
        rnInterface: 'lang',
        popupWindowSize: {
            w: '990',
            h: '535'
        }
    },

    showHelpPopup: function (what, p1, p2) {
        this.showHelp(what, p1, p2, 'popup');
    },

    showHelp: function (what, p1, p2, where) {
        what = what || 'HOME';
        var opts = {};

        switch (what.toUpperCase()) {
            case 'HOME':
                //empty opts will work
                break;

            case 'ANSWER':
                if (!isNaN(parseInt(p1))) {
                    opts.answerID = p1;
                }

                if (typeof(p2) !== 'undefined' && p2.match(/^#[a-zA-Z0-9_-]+$/gi)) { // a bit of validation on the anchor string
                    opts.anchor = p2.toString();
                }
                break;

            case 'SEARCH':
                if (typeof(p1) !== 'undefined') {
                    opts.searchTerm = p1.toString();
                }
                break;

            case 'CATEGORY':
                if (!isNaN(parseInt(p1))) {
                    opts.categoryID = p1;
                }
                break;

            case 'CONTACT':
                opts.contact = true;
                if (typeof(p1) !== 'undefined' && p1 === 'call') {
                    opts.anchor = p1;
                }
                break;
        }

        if (typeof(where) !== 'undefined') {
            opts.where = where.toString();
        }

        this.openCP(opts);
    },

    launchLiveChat: function (errorMsg) {
        var url = this.getBaseURL() + 'chat/chat_launch';

        if (typeof(errorMsg) === 'string') {
            var msgMatch = errorMsg.match(/[a-zA-Z0-9_-]+$/gi);

            if (msgMatch !== null){
                return window.open(url + '/_icf_77/' + msgMatch[0]);
            }
        }

        window.open(url);
    },

    openCP: function (options) {
        var targetURL = this.getBaseURL();

        options = options || {};

        if (!isNaN(parseInt(options.answerID))) { // an answer ID was requested
            targetURL += 'answers/detail/a_id/' + options.answerID + '/';

            if (typeof(options.anchor) !== "undefined") { // an anchor was also requested
                targetURL += options.anchor;
            }

        } else if (typeof(options.searchTerm) !== "undefined") {  // a search term was requested
            targetURL += 'answers/search_results/st/5/kw/' + options.searchTerm + '/page/1/search/1';

        } else if (!isNaN(parseInt(options.categoryID))) { // a category ID was requested
            targetURL += 'answers/list/c/' + options.categoryID;

        } else if (typeof(options.contact) !== 'undefined') {
            targetURL += 'ask';

            if (typeof(options.anchor) !== 'undefined') {
                targetURL += '#call';
            }
        }

        // Finally open the targetURL
        if (options.where == 'popup') {
            // TODO: give focus to this window (in case it was already opened, to make sure we don't leave it blurred when loading a new content on it)
            window.open(targetURL, 'HelpCentre', 'width=' + this.defaults.popupWindowSize.w + ',height=' + this.defaults.popupWindowSize.h + ',scrollbars=yes,resizable=no');
        } else {
            window.open(targetURL);
        }
    },

    getRNInterface: function () {
        var hostname = window.location.hostname;
        var pathname = window.location.pathname;

        if (hostname.match(/\.es$/gi)) {
            return 'es';
        }
        if (hostname.match(/\.it$/gi)) {
            return 'it';
        }

        var langVsInterface = {
            'es': 'sp',
            'es-es': 'sp',
            'es-ca': 'lang',
            'en-ie': 'lang',
            'en-ca': 'lang',
            'en-gb': 'lang',
            'tr': 'lang', // is it still in use?
            'no': 'lang', // is it still in use?
            'ro': 'ro',
            'hu': 'hu',
            'sv': 'sv',
            'sv-se': 'sv',
            'ru': 'ru',
            'sl': 'si',
            'zh': 'lang-tch',
            'cn': 'lang-sch',
            'zh-cn': 'lang-sch',
            'zh-hk': 'lang-tch',
            'fi': 'fi',
            'cs': 'cz',
            'fr-fr': 'fr',
            'fr': 'fr',
            'pl-pl': 'pl',
            'pl': 'pl',
            'de': 'de',
            'de-de': 'de',
            'at': 'de', // is it still in use?
            'pt': 'pt',
            'br': 'pt', // is it still in use?
            'sr': 'rs',
            'ja-jp': 'jp',
            'ja': 'jp',
            'el-gr': 'lang-gr'
        };

        var returnFromForEach = [];
        Object.keys(langVsInterface).forEach(function (key) {
            var pattern = new RegExp("\/" + key + "(\/|$)", "gi");
            var matchPosition = pattern.exec(pathname);

            if (matchPosition && ( !('position' in returnFromForEach) || returnFromForEach['position'] > matchPosition.index) ) {
                returnFromForEach['interface'] = langVsInterface[key];
                returnFromForEach['position'] = matchPosition.index;
            }
        });

        return 'interface' in returnFromForEach ? returnFromForEach['interface'] : this.defaults.rnInterface;
    },

    getBaseURL: function () {
        var hostname = window.location.hostname;
        var URL = 'https://williamhill-' + this.getRNInterface();

        if (hostname.match(/\.williamhill-pp1\./gi)) {
            URL += '--tst';
        } else if (hostname.match(/\.williamhill-pp2\./gi)) {
            URL += '--tst2';
        } else if (hostname.match(/\.williamhill-pp3\./gi)) {
            URL += '--tst3';
        }

        URL += '.custhelp.com/app/';

        return URL;
    }
};

function showHelp (whereFrom, productID, metaID, anchor, subFrame, viewMode) {
    if (typeof(metaID) === 'undefined' || typeof(metaID) === 'object') {
        return rn.showHelp('HOME');
    }

    if (typeof(anchor) === 'undefined') {
        return rn.showHelp('ANSWER', metaID);
    }

    return rn.showHelp('ANSWER', metaID, anchor);
}

function launchLiveChat (errorMsg) {
    return rn.launchLiveChat(errorMsg);
}

// Export module in UMD (Universal Module Definition)
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but only CommonJS-like
        // environments that support module.exports, like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.returnExports = factory();
    }
}(typeof self !== 'undefined' ? self : this, function () {

    return {
        rn: rn,
        showHelp: showHelp,
        launchLiveChat: launchLiveChat
    };
}));
